module.exports = __webpack_public_path__ + "img/d201111-2.420cedd1.jpg";